import { MEDIA_URL } from "static-content/RelativeUrlHelperFunctions";
import { device } from "../styles/Reset";
import styled, { keyframes, css } from "styled-components";
import theme from "styled-theming";

const clientNotificationLaptop = theme("client", {
  bbva: css`
    top: auto;
    bottom: 35%;
    position: absolute;
    left: -160%;
    width: 40%;
    border-radius: 10px;
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      right: 30px;
      background: #f6f7f6;
      width: 30px;
      height: 30px;
      display: inline-block;
      transform: rotateZ(45deg);
    }
  `,
});

const fadeInOut = keyframes`
  0%{opacity:0;transform: translateY(-75%);}
  10% {opacity: 0;transform:translateY(-75%);}
  20%{opacity:1;transform: translateY(0%);}
  90%{opacity:1;transform: translateY(0%);}
  100% {opacity: 0;transform: translateY(0%);}
`;

const fadeIn = keyframes`
0%{opacity:0;}
  10% {opacity: 0;}
  20%{opacity:1;}
  90%{opacity:1;}
  100% {opacity: 1;}
`;

export const NotificationWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 60px;
  background: ${(props) => props.theme.themeGlobal.main};
  z-index: 3650;
  margin: 0 auto;
  right: 0;
  border-radius: 0 0 8px 8px;
  border-bottom: 3px solid #fff;
  opacity: 0;
  opacity: 1;
  animation: ${fadeInOut};
  animation-duration: 6s;
  animation-duration: ${(props) => props.duration}s;
  animation-fill-mode: both;
  @media ${device.laptop} {
    position: static;
    z-index: 2000;
    margin-top: 3px;
    width: 300px;
    height: 50px;
    border: 0;
    border-left: 6px solid ${(props) => props.theme.themeGlobal.positive};
    background: #f6f7f6;
    border-radius: 0 5px 5px 0;
    animation: ${fadeIn};
    animation-duration: 12s;
    animation-duration: ${(props) => props.duration * 2}s;
    display: inline-block;
    ${clientNotificationLaptop};
  }
`;

export const NotificationImage = styled.div`
  width: 35px;
  height: 35px;
  border-radius: 3px;
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 5px;
  margin: auto;
  background-image: ${(props) =>
    `url(${
      !props.fileName ? `${MEDIA_URL}/branding/notification` : `${MEDIA_URL}/notifications/${props.fileName}`
    }.svg)`};
  background-color: ${(props) => (!props.fileName ? "transparent" : props.theme.themeGlobal.bgNeutral)};
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  @media ${device.laptop} {
    top: 5px;
    width: 40px;
    height: 40px;
    left: 0;
  }
`;

export const NotificationTitle = styled.div`
  font-weight: bold;
  margin-left: 40px;
  margin-top: 0;
  text-transform: uppercase;
  font-size: 1.2rem;
`;

export const NotificationCard = styled.div`
  max-width: 250px;
  width: 250px;
  display: inline-block;
  position: relative;
  font-size: 1.3rem;
  height: 90%;
  padding: 7px;
  text-align: left;
  background: #fff;
  margin: 3px auto;
  border-radius: 3px;
  border-left: 10px solid #efefef;

  > p {
    margin-left: 40px;
    line-height: 1.1rem;
  }
  @media ${device.laptop} {
    font-size: 1.2rem;
    background: none;
    padding: 0 8px;
    border: none;
    height: 39px;
  }
`;

export const NotificationTime = styled.p`
  display: inline-block;
  position: absolute;
  top: 5px;
  right: 5px;
  text-align: right;
  color: #ccc;
  font-size: 1.1rem;
`;

export const NotificationWrappper = styled.div`
  > h2 {
    border-bottom: 2px solid #f7f7f7;
    text-transform: uppercase;
    font-size: 1.2rem;
    padding-bottom: 5px;
    padding-top: 18px;
    text-align: left;
    margin-left: 20px;
  }
  > p {
    margin: 8px 0;
  }
  @media ${device.laptop} {
    > h2 {
      padding-top: 0;
    }
  }
`;
